export const SET_SHOW_FORM = "SET_SHOW_FORM";
export const SET_SELECT_IMAGE = "SET_SELECT_IMAGE";
export const SET_TITLE = "SET_TITLE";
export const SET_IS_EDIT = "SET_IS_EDIT";